// Generated by CoffeeScript 2.7.0
var isInTable;

import {
  Slice,
  Fragment
} from 'prosemirror-model';

import {
  addColumnBefore,
  addColumnAfter,
  addRowBefore,
  addRowAfter,
  deleteColumn,
  deleteRow,
  deleteTable
} from 'prosemirror-tables';

import schema from './schema.js';

isInTable = function(state) {
  var $head, d, i, ref;
  $head = state.selection.$head;
  for (d = i = ref = $head.depth; (ref <= 0 ? i < 0 : i > 0); d = ref <= 0 ? ++i : --i) {
    if ($head.node(d).type.spec.tableRole === "row") {
      return true;
    }
  }
  return false;
};

export default {
  active: isInTable,
  create: function(row, col, state, dispatch, view) {
    var cells, from, paragraph, rows, slice, table;
    ({from} = state.selection);
    cells = [];
    while (col--) {
      cells.push(schema.nodes.table_cell.createAndFill());
    }
    rows = [];
    while (row--) {
      rows.push(schema.nodes.table_row.createAndFill(null, cells));
    }
    paragraph = schema.nodes.paragraph.create();
    table = schema.nodes.table.createAndFill(null, rows);
    slice = new Slice(Fragment.from([table, paragraph]), 0, 0);
    dispatch(state.tr.replaceSelection(slice).scrollIntoView());
    return view.focus();
  },
  commands: {
    row: [
      {
        content: '删除行',
        run: deleteRow
      },
      {
        content: '在上面插入行',
        run: addRowBefore
      },
      {
        content: '在下面插入行',
        run: addRowAfter
      }
    ],
    column: [
      {
        content: '删除列',
        run: deleteColumn
      },
      {
        content: '在左面插入列',
        run: addColumnBefore
      },
      {
        content: '在右面插入列',
        run: addColumnAfter
      }
    ],
    table: [
      {
        content: '删除表格',
        run: deleteTable
      }
    ]
  }
};
